module.exports = "/images/vendor/flag-icon-css/flags/1x1/mw.svg?baf490bf505c107037b6720672f44e9e";